import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template", "output"]

  connect() {
    this.updateOutput()
  }

  add(event) {
    event.preventDefault()
    const template = this.templateTarget.innerHTML
    const newRow = document.createElement("div")
    newRow.innerHTML = template
    newRow.className = "flex items-center gap-2 mb-2"
    newRow.dataset.specsFieldsTarget = "row"
    this.containerTarget.appendChild(newRow)
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest("[data-specs-fields-target='row']")
    if (row) {
      row.remove()
      this.updateOutput()
    }
  }

  updateOutput() {
    const rows = this.containerTarget.querySelectorAll("[data-specs-fields-target='row']")
    const specs = []

    rows.forEach((row) => {
      const labelInput = row.querySelector("[data-field='label']")
      const valueInput = row.querySelector("[data-field='value']")

      if (labelInput && valueInput && (labelInput.value.trim() || valueInput.value.trim())) {
        specs.push({
          label: labelInput.value.trim(),
          value: valueInput.value.trim()
        })
      }
    })

    this.outputTarget.value = JSON.stringify(specs)
  }
}
